<div class="row row-grid" *ngIf="doctorPrescriptions.length; else empty">
  <div class="col-md-6 col-lg-4 col-xl-3" *ngFor="
    let patientPrescription of doctorPrescriptions ;  let i = index " style="cursor: pointer;">
    <div class="card widget-profile pat-widget-profile">
      <div class="card-body">
        <div class="pro-widget-content">
          <div class="profile-info-widget">
            <a class="booking-doc-img">
              <img [src]="avatarSrc(patientPrescription)" [alt]="patientPrescription.patientFristName + ' ' + patientPrescription.patientLastName" image />
            </a>
            <div class="profile-det-info">
              <h3><a class="label">{{patientPrescription.patientFristName}} {{patientPrescription.patientLastName}}</a></h3>
              <div class="patient-details">
                <h5><b>Date Naissance:</b> {{patientPrescription.patientBirthDate|
                  date:"dd/MM/yyyy"}}</h5>
                <h5 class="mb-0">
                  <i class="feather-map-pin"></i> {{patientPrescription.patientaddress}}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="patient-info">
          <ul>
            <!-- <li>Mobile : <span class="mx-2">{{ patientPrescription.patient.mobilePhone1 || "---" }}</span></li> -->
            <li>Date Prescription : <span class="mx-2">{{patientPrescription.datePrescription| date: "dd/MM/YYYY"}}</span></li>
            <li>Start Time : <span>{{patientPrescription.startDateTime | millisecondsToTime}}</span></li>
          </ul>
        </div>
        <div class="table-action">
          <a title="View prescription" [routerLink]="['patients',patientPrescription.patientId,'prescriptions',patientPrescription.id]" class="btn btn-sm bg-info-light">
            <i class="feather-eye"> </i>
          </a>
          <a title="Modifier Prescription" [routerLink]="['patients',patientPrescription.patientId,'prescriptions',patientPrescription.id,'edit']"
            class="btn btn-sm bg-success-light">
            <i class="feather-edit"> </i>
          </a>
          <a title="Supprimer  prescription" (click)="deletePrescription(i)" class="btn btn-sm bg-danger-light">
            <i class="feather-trash"> </i>
          </a>
        </div>
      </div>
    </div>
  </div>

</div>
<ng-template #empty>
  <tr>
    <td colspan="8" style="text-align: center;">
      <span style="text-align: center; width: 100%;">
        Pas de Prescription !
      </span>
    </td>
  </tr>
</ng-template>
<app-pagination [pageRequest]="pageRequest" (content)="doctorPrescriptions = $event"></app-pagination>